export function isValidDate(value: any): boolean {
  // Convert value to a string and trim it
  const strValue = String(value).trim();

  // Check if the trimmed string can be parsed into a valid date
  const date = new Date(strValue);
  return !isNaN(date.getTime());
}
